import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SectionHeader from "../common/sectionHeader";
import INFO from "../../data/user";
import "./styles/skillsGrid.css";

const SkillsGrid = () => {
	const [activeCategory, setActiveCategory] = useState(INFO.skills[1]?.category || "Backend");

	const currentGroup = INFO.skills.find((s) => s.category === activeCategory) || INFO.skills[0];

	return (
		<section className="skills-section">
			<SectionHeader
				tag="Technical Stack"
				title="Skills & Engineering"
				highlight="Capabilities"
				subtitle="Categorized proficiency across backend services, full-stack frameworks, database tuning, and cloud fundamentals."
			/>

			<div className="skills-tabs">
				{INFO.skills.map((group, idx) => (
					<button
						key={idx}
						className={`skill-tab-btn ${activeCategory === group.category ? "active" : ""}`}
						onClick={() => setActiveCategory(group.category)}
					>
						{group.category}
					</button>
				))}
			</div>

			<AnimatePresence mode="wait">
				<motion.div
					key={activeCategory}
					className="skills-grid-container"
					initial={{ opacity: 0, y: 10 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -10 }}
					transition={{ duration: 0.25 }}
				>
					{currentGroup.items.map((item, idx) => (
						<div key={idx} className="skill-item-card">
							<span className="skill-item-name">{item.name}</span>
							<span className="skill-item-level">{item.level}</span>
						</div>
					))}
				</motion.div>
			</AnimatePresence>
		</section>
	);
};

export default SkillsGrid;
